import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { OperatorEnum } from 'src/app/shared/constants/common.constants';
import { AdminFeasibilityService } from '../admin-feasibility.service';

@Component({
    selector: 'app-manage-admin-feasibility',
    templateUrl: './manage-admin-feasibility.component.html',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, InputTextModule, TextareaModule, SelectModule, CheckboxModule, ButtonDirective, TranslateModule]
})
export class ManageAdminFeasibilityComponent implements OnInit {

    feasibilityRuleFormGroup!: FormGroup;
    feasibilityRuleValues: string[] = [];
    operatorOptions = [];

    constructor(
		public readonly adminFeasibilityService: AdminFeasibilityService,
		private readonly translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.prepareFormGroup();
        this.prepareOperatorOptions();
    }

    prepareOperatorOptions(): void {
        const operatorLabelPrefix = 'ADMINISTRATION.FEASIBILITY.OPERATORS.';

        this.operatorOptions = Object.keys(OperatorEnum).map(key => {
            const operatorKey = OperatorEnum[key as keyof typeof OperatorEnum];
            return {
                label: this.translateService.instant(`${operatorLabelPrefix}${operatorKey}`),
                value: operatorKey
            };
        });
    }

    prepareFormGroup(): void {
        const ruleConcept = this.adminFeasibilityService.selectedRule?.ruleConcept || undefined;
        const ruleDescription = this.adminFeasibilityService.selectedRule?.ruleDescription || undefined;
        const fieldName = this.adminFeasibilityService.selectedRule?.fieldName || undefined;
        const fieldName2 = this.adminFeasibilityService.selectedRule?.fieldName2 || undefined;
        const operator = this.adminFeasibilityService.selectedRule?.operator || OperatorEnum.Equals;
        const value = this.adminFeasibilityService.selectedRule?.value || undefined;
        const active = this.adminFeasibilityService.selectedRule?.active === false ? false : true;	// If active is false, set it to false, otherwise set it to true

        this.feasibilityRuleFormGroup = new FormGroup({
            ruleConcept: new FormControl(ruleConcept, [Validators.required]),
            ruleDescription: new FormControl(ruleDescription, [Validators.required]),
            fieldName: new FormControl(fieldName, [Validators.required]),
            fieldName2: new FormControl(fieldName2),
            operator: new FormControl(operator, [Validators.required]),
            value: new FormControl(value, [Validators.required]),
            active: new FormControl(active),
            translationLabel: new FormControl('test'),
        });
    }

    handleSaveFeasibilityRule(): void {
        if (this.feasibilityRuleFormGroup.invalid) {
            // TODO: toast if the form is invalid
            return;
        }
        if (this.adminFeasibilityService.selectedRule) {
            this.adminFeasibilityService.updateFeasibilityRules(this.feasibilityRuleFormGroup.value).catch(error => {console.error(error);});
        } else {
            this.adminFeasibilityService.createFeasibilityRule(this.feasibilityRuleFormGroup.value).catch(error => {console.error(error);});
        }
    }
}
